import tippy from 'tippy.js';




tippy('[data-tippy-content]', {
    content(reference) {
      const id = reference.getAttribute('data-template');
      const template = document.getElementById(id);
      return template.innerHTML;
    },
    interactive: true,
    allowHTML: true,
    theme: 'products',
    arrow: true,
    // duration: 20000000,
  });